import {
  WindowLabels,
  type ContextMenuPayload,
  MenuEventType,
  MenuTypes,
} from '@electron/shared';

import { ElectronAPI } from '../base/ElectronAPI';

export class MenuAPI extends ElectronAPI {
  showContextMenu(
    payload: ContextMenuPayload = {
      window: WindowLabels.main,
      type: MenuTypes.default,
      args: undefined,
    }
  ) {
    return this.invoke<void>(MenuEventType.ContextMenu, payload);
  }
}
